import { safeLocalStorage } from '@/lib/browserStorage';
// Local-only backup of recently deleted drill data so it can be restored.
// Data lives only on the device that performed the deletion.

const HOLES_KEY = "drilllog:deleted-holes";
const RUNS_KEY = "drilllog:deleted-runs";
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // keep up to 7 days
const MAX_ITEMS = 10;

const BUILTINS = ["id", "created_date", "updated_date", "created_by_id"];

function read(key) {
  try {
    return JSON.parse(safeLocalStorage.getItem(key) || "[]");
  } catch {
    return [];
  }
}

function write(key, items) {
  const now = Date.now();
  const fresh = items
    .filter((i) => now - i.deletedAt < MAX_AGE_MS)
    .slice(0, MAX_ITEMS);
  safeLocalStorage.setItem(key, JSON.stringify(fresh));
  return fresh;
}

export function stripBuiltins(obj) {
  if (!obj) return {};
  const out = {};
  Object.keys(obj).forEach((k) => {
    if (!BUILTINS.includes(k)) out[k] = obj[k];
  });
  return out;
}

export function backupDeletedHole(sheet, runs) {
  const items = read(HOLES_KEY);
  const entry = {
    id: sheet?.id || Date.now().toString(),
    deletedAt: Date.now(),
    sheet,
    runs: runs || [],
  };
  write(HOLES_KEY, [entry, ...items.filter((i) => i.id !== entry.id)]);
}

export function listDeletedHoles() {
  const fresh = write(HOLES_KEY, read(HOLES_KEY));
  return fresh;
}

export function removeDeletedHole(id) {
  write(
    HOLES_KEY,
    read(HOLES_KEY).filter((i) => i.id !== id)
  );
}

export function backupDeletedRun(run) {
  if (!run) return;
  const items = read(RUNS_KEY);
  const entry = { id: run.id, deletedAt: Date.now(), run };
  write(RUNS_KEY, [entry, ...items.filter((i) => i.id !== entry.id)]);
}

export function listDeletedRuns() {
  const fresh = write(RUNS_KEY, read(RUNS_KEY));
  return fresh;
}

export function removeDeletedRun(id) {
  write(
    RUNS_KEY,
    read(RUNS_KEY).filter((i) => i.id !== id)
  );
}